let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c4rFB")).then(() => parcelRequire('iOQd2'));